<ng-container [formGroup]="formGroup()">
    <div class="form-field pt-0">
        <label class="form-control-label">{{ 'label' | transloco }}</label>
        <mat-form-field
            appearance="outline"
            class="text-sm w-full">
            <mat-select
                formControlName="label"
                (selectionChange)="onLabelChange.emit($event)">
                @for (attribute of symbologyEditService.bookmarkedAttributes(); track attribute) {
                    <mat-option [value]="attribute.column">
                        @if (!attribute.column.length) {
                            {{ 'noLabel' | transloco }}
                        } @else if (attribute.column === 'businessIdentifier') {
                            {{ 'businessIdentifier' | transloco }}
                        } @else {
                            {{ attribute.column }}
                        }
                    </mat-option>
                }
            </mat-select>
            @for (error of formGroup()!.controls.label.errors | keyvalue; track error) {
                <mat-error class="max-h-4 text-xs">{{ formService.getErrorMessage(error) }}</mat-error>
            }
        </mat-form-field>
    </div>
    <div class="form-field pt-0">
        <label class="form-control-label">{{ 'labelSize' | transloco }}</label>
        <mat-form-field
            appearance="outline"
            class="text-sm">
            <input
                formControlName="size"
                matInput
                min="0"
                step="1"
                type="number" />
            @for (error of formGroup()!.controls.size.errors | keyvalue; track error) {
                <mat-error class="max-h-4 text-xs">{{ formService.getErrorMessage(error) }}</mat-error>
            }
        </mat-form-field>
    </div>
    <div class="form-field pt-0">
        <label class="form-control-label">{{ 'label' | transloco }} {{ 'minZoom' | transloco | lowercase }}</label>
        <mat-form-field
            appearance="outline"
            class="text-sm">
            <input
                formControlName="minZoom"
                matInput
                max="24"
                min="1"
                step="1"
                type="number" />
            @for (error of formGroup()!.controls.minZoom.errors | keyvalue; track error) {
                <mat-error class="max-h-4 text-xs">{{ formService.getErrorMessage(error) }}</mat-error>
            }
        </mat-form-field>
    </div>
    <div class="form-field pt-0">
        <label class="form-control-label">{{ 'label' | transloco }} {{ 'maxZoom' | transloco | lowercase }}</label>
        <mat-form-field
            appearance="outline"
            class="text-sm">
            <input
                formControlName="maxZoom"
                matInput
                max="24"
                min="1"
                step="1"
                type="number" />
            @for (error of formGroup()!.controls.maxZoom.errors | keyvalue; track error) {
                <mat-error class="max-h-4 text-xs">{{ formService.getErrorMessage(error) }}</mat-error>
            }
        </mat-form-field>
    </div>
</ng-container>
